<app-main-layout>
  <div class="app-container">
    <router-outlet></router-outlet>
  </div>
</app-main-layout>
